// extracted by mini-css-extract-plugin
export default {"root":"App_root__40Hjl","main-content":"App_main-content__qz0Ex","header":"App_header__fhC8n","transition_group":"App_transition_group__YJOBy","navbar":"App_navbar__gqftH"};